import { setCookie, getCookie, eraseCookie } from '../base/cookies';

/**
 * Handle Announcement bar visibility in header
 *
 * @param {}
 * @return {void}
 */

function handleAnnouncementBarActions() {
  const $announcementBar = $('.js-announcement-bar');
  const $closeCookieBtn = $('.js-announcement-btn');
  const cookieActive = getCookie('_announcement_bar');
  const activeClass = 'is-opened';
  const $main = $('.js-main');

  const handleOffsets = () => {
    let headerHeight = $('.js-header').outerHeight();
    let mainOffset = Math.floor(headerHeight);

    $main.css('padding-top', `${mainOffset}px`);
  }

  if (!cookieActive) {
    $announcementBar.show().addClass(activeClass);
    setTimeout(handleOffsets, 400);
  }

  $closeCookieBtn.on('click', function(e) {
    e.preventDefault();

    if ($announcementBar.hasClass(activeClass)) {
      $announcementBar.slideUp().removeClass(activeClass);
    }

    setTimeout(handleOffsets, 400);
    setCookie('_announcement_bar', 'none', 3);
  });
}

$(window).on('load', function() {
  handleAnnouncementBarActions();
});

$(window).on('resize orientationchange', function() {
  handleAnnouncementBarActions();
});
